export const apiPaths = {
  user: {
    me: '/v1/auth/me',
    devices: '/v1/mgmt/user/trusteddevices/list',
    selectTenant: '/v1/auth/tenant/select',
  },
};
